// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"box-wrapper__wrapper"};